import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=5d7749c6&scoped=true"
import script from "./CustomerRegister.vue?vue&type=script&lang=js"
export * from "./CustomerRegister.vue?vue&type=script&lang=js"
import style0 from "./CustomerRegister.vue?vue&type=style&index=0&id=5d7749c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7749c6",
  null
  
)

export default component.exports